export default __webpack_public_path__ + "static/media/kitchen3-before3-480w.28e7675d.avif";